import React, { useState, useEffect } from "react";
import Form, {
  Item,
  RequiredRule,
  Label,
  GroupItem,
  StringLengthRule,
} from "devextreme-react/form";
import { SelectBox } from "devextreme-react";
import { formatMessage } from "devextreme/localization";
import notify from "devextreme/ui/notify";
import "./style.scss";
import { listApprovalType, changeDisplayedName, axios } from "../../../common";

export default function FormApprovalSetting({ formData }) {
  const [approvalType, setApprovalType] = useState("");
  const [employee, setEmployee] = useState([]);

  useEffect(() => {
    handleFetch();
  }, []);

  const handleFetch = async () => {
    try {
      const { data } = await axios.get("Employee", {
        params: {
          $filter: "DateOut eq null",
          $select: "Oid,EmployeeCode,FullName",
        },
      });
      setEmployee(data.value);
    } catch (error) {
      notify(error);
    }
  };

  function gridBoxEmployeeDisplayExpr(item) {
    return item && `${item.EmployeeCode} - ${item.FullName}`;
  }

  const dataTypeEditorOptions = {
    items: listApprovalType,
    searchEnabled: true,
    value: approvalType,
    displayExpr: changeDisplayedName(),
    valueExpr: "id",
    placeholder: formatMessage("PlaceholderApprovalType"),
    searchMode: "contains",
    showClearButton: true,
    onValueChanged: (e) => {
      setApprovalType(e.value);
    },
  };

  return (
    <div>
      <Form
        colCount={2}
        id="form"
        formData={formData.current}
        focusStateEnabled={true}
        className={"form-editor"}
        onContentReady={(e) => {
          e.component.focus();
        }}
      >
        <GroupItem>
          <Item
            dataField="ApprovalType"
            editorType="dxSelectBox"
            editorOptions={dataTypeEditorOptions}
          >
            <Label text={formatMessage("ApprovalType")} />
            <RequiredRule message={formatMessage("ValidateApprovalType")} />
          </Item>
          <Item dataField="Employee">
            <Label text={formatMessage("Employee")} />
            <SelectBox
              valueExpr="Oid"
              dataSource={employee}
              displayExpr={gridBoxEmployeeDisplayExpr}
              itemRender={gridBoxEmployeeDisplayExpr}
              onValueChanged={(e) => {
                formData.current.EmployeeOid = e.value;
              }}
              searchEnabled={true}
            />
            <RequiredRule message="Employee RequiredRule" />
          </Item>
        </GroupItem>
        <GroupItem>
          <Item dataField="Description" editorType="dxTextBox">
            <StringLengthRule max="250" />
            <Label text={formatMessage("Description")} />
          </Item>
          <Item
            dataField="IsActive"
            editorType="dxCheckBox"
            editorOptions={{
              value: true,
            }}
          >
            <Label text={formatMessage("IsActive")} />
          </Item>
        </GroupItem>
      </Form>
    </div>
  );
}
